import { Store } from '@reduxjs/toolkit';

interface IRef {
  redirect(store: Store): void;
}

class RedirectManager {
  defaultRedirect: IRef | null = null;

  register(ref: IRef) {
    if (ref) {
      this.defaultRedirect = ref;
    }
  }

  getDefault() {
    return this.defaultRedirect;
  }
}
export default new RedirectManager();
